<template>
  <div class="container_box">
    <Tabs v-model="pageParams.merchantType" :animated="false" class="tabs_styles" @on-click="search()">
      <TabPane v-for="item in logisticsProvidersTypeList" :label="item.label" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="`${configCharacters()}` + $t('key1005383')" prop="name">
              <Input :placeholder="$t('key1000324')" v-model.trim="pageParams.name" clearable></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1005384')">
              <Cascader
                v-model="shippingMethodModel"
                :load-data="loadData"
                @on-change="changeShippingMethod"
                @on-visible-change="(value)=> showShippingData(value, true)"
                :data="shippingMethodData"
                filterable
                change-on-select>
              </Cascader>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001522')">
              <local-tabButton :tabButtonList="statusList" @selectStatus="statusBtn"></local-tabButton>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search" :disabled="tableLoading">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Button type="primary" @click="$refs['logisticsChannel'].initYmsLogisticsChannelData('add')"
        v-if="getPermission('ymsLogisService_insert')">{{ $t('key1001340') + configCharacters() + $t('key1001581') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="510"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--关联物流-->
    <relationLogistics ref="relationLogistics" :merchantType="pageParams.merchantType" @updateData="updateData"></relationLogistics>
    <!--物流渠道-->
    <ymsLogisticsChannelModal ref="logisticsChannel" :merchantType="pageParams.merchantType" @updateData="updateData"></ymsLogisticsChannelModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import relationLogistics from "@/views/yms/components/logisticsManage/relationLogistics";
import ymsLogisticsChannelModal from "@/views/yms/components/logisticsManage/ymsLogisticsChannelModal";
import api from '@/api/';
import {ENABLEDISABLESTATUS} from "@/utils/enum";
import {_handleMultilingualFields, setConfigCharacters} from "@/utils/common";

export default {
  name: 'ymsLogistics',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        name: '',
        carrierId: null,
        shippingMethodId: null,
        merchantType: '2', /* 1 混合物流 2 分销商 3 供应商 */
        status: null,
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      curPage: 1,
      tableColumns: [
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005379')}`,
          key: 'name',
          minWidth: 110,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000409'),
          key: 'code',
          minWidth: 110,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005380'),
          key: 'merchantShippingMethodId',
          width: 400,
          align: 'center',
          render: (h, params) => {
            let ymsLogisServiceMappingList = params.row.ymsLogisServiceMappingList;
            let arr = [];
            if (ymsLogisServiceMappingList) {
              ymsLogisServiceMappingList.map((ele) => {
                if (v.relatedLogisticsList) {
                  v.relatedLogisticsList.map((item) => {
                    if (ele.shippingMethodId === item.shippingMethodId) {
                      let carrierShippingMethodName = _handleMultilingualFields(item.carrierShippingMethodName);
                      let carrierName = _handleMultilingualFields(item.carrierName);
                      arr.push(h('div', {style: {margin: '5px 0'}}, carrierName + ' > ' + carrierShippingMethodName));
                    }
                  });
                }
              });
              return h('div', arr);
            } else {
              return '-';
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000410'),
          key: 'times',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            let minEfficiency = params.row.minEfficiency;
            let maxEfficiency = params.row.maxEfficiency;
            let text = '';
            if (minEfficiency < maxEfficiency) {
              text = minEfficiency + ' - ' + maxEfficiency + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000411');
            } else {
              text = maxEfficiency + ' - ' + minEfficiency + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000411');
            }
            return h('div', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          width: 120,
          align: 'center',
          render(h, params) {
            let status = params.row.status;
            let text = '';
            v.statusList.map((item) => {
              if (item.value === status) {
                text = item.title;
              }
            });
            return h('span', {
              class: status === 1 ? 'openStatus' : 'stopStatus'
            }, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          width: 200,
          align: 'center',
          render(h, params) {
            let status = params.row.status === 1;
            let ymsLogisServiceId = params.row.ymsLogisServiceId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: v.getPermission('ymsLogisService_detail'),
                    clickFn: () => {
                      v.$refs['logisticsChannel'].initYmsLogisticsChannelData('look', ymsLogisServiceId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsLogisService_update'),
                    clickFn: () => {
                      v.$refs['logisticsChannel'].initYmsLogisticsChannelData('edit', ymsLogisServiceId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: status && v.getPermission('ymsLogisService_disable'),
                    clickFn: () => {
                      v.enableDisableBtn(params.row.status, params.row.ymsLogisServiceId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: params.row.status === 0 && v.getPermission('ymsLogisService_enable'),
                    clickFn: () => {
                      v.enableDisableBtn(params.row.status, params.row.ymsLogisServiceId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005381'),
                    show: v.getPermission('ymsLogisServiceMapping_save'),
                    clickFn: () => {
                      v.$refs['relationLogistics'].getRelatedLogisticsList(params.row.name, params.row.ymsLogisServiceId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      statusList: ENABLEDISABLESTATUS,
      relatedLogisticsList: [],
      logisticsProvidersTypeList: [
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005382'), value: '2'},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001666'), value: '3'}
      ]
    };
  },
  created() {
    this.reset();
    this.search();
  },
  methods: {
    // 选择关联物流
    changeShippingMethod(value, data) {
      let v = this;
      if (value.length === 0) {
        v.pageParams.carrierId = null;
        v.pageParams.shippingMethodId = null;
      } else if (value.length === 1) {
        v.pageParams.carrierId = value[0];
        v.pageParams.shippingMethodId = null;
      } else if (value.length === 2) {
        v.pageParams.carrierId = value[0];
        v.pageParams.shippingMethodId = value[1][0];
      }
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置数据
    reset() {
      let v = this;
      v.statusBtn(0, null);
      v.$nextTick(() => {
        v.$refs['pageParams'].resetFields();
      });
      v.shippingMethodModel = [];
      v.pageParams.carrierId = null;
      v.pageParams.shippingMethodId = null;
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsLogisService_query')) {
        v.tableLoading = true;
        let params = Object.assign({}, v.pageParams);
        params.merchantType = Number(v.pageParams.merchantType);
        v.axios.post(api.post_ymsLogisService_query, params).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              let list = data.list || [];
              v.total = data.total;
              let merchantShippingMethodIdPos = [];
              if (list.length > 0) {
                list.forEach((n, i) => {
                  if (n.ymsLogisServiceMappingList) {
                    n.ymsLogisServiceMappingList.map((item) => {
                      merchantShippingMethodIdPos.push(item.shippingMethodId);
                    });
                  }
                });
                if (merchantShippingMethodIdPos.length > 0) {
                  Promise.resolve(v.axios.post(api.post_carrierShippingMethod_queryCarrierShippingName, JSON.stringify(merchantShippingMethodIdPos)).then(res => {
                    if (res.data.code === 0) {
                      let newData = res.data.datas || [];
                      if (newData.length > 0) {
                        v.relatedLogisticsList = newData;
                      }
                    }
                  })).then(() => {
                    v.tableData = list;
                    v.total = data.total;
                    v.$nextTick(() => {
                      v.tableLoading = false;
                    });
                  });
                } else {
                  v.tableData = list;
                  v.$nextTick(() => {
                    v.tableLoading = false;
                  });
                }
              } else {
                v.tableLoading = false;
              }
            } else {
              v.tableLoading = false;
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 选取状态类型
    statusBtn(index, value) {
      let v = this;
      v.pageParams.status = value;
      v.statusList.forEach((n, i) => {
        n.selected = i === index;
      });
    },
    // 启用、停用按钮
    enableDisableBtn(status, ymsLogisServiceId) {
      let v = this;
      let url = '';
      let text = '';
      // 停用
      if (status === 1) {
        url = api.put_ymsLogisService_disable;
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002472');
      }
      // 启用
      else {
        url = api.put_ymsLogisService_enable;
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002473');
      }
      v.axios.put(url + ymsLogisServiceId).then(res => {
        if (res.data.code === 0) {
          v.$Message.success(text);
          v.pageParamsStatus = true;
        }
      });
    },
    // 新增、编辑物流渠道成功后，更新列表数据
    updateData() {
      this.pageParamsStatus = true;
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    ymsLogisticsChannelModal,
    relationLogistics
  },
};
</script>

<style lang="less" scoped>
.tabs_styles {
  /deep/ .ivu-tabs-bar {
    border-bottom: none;
    background-color: #fff;
    padding: 8px 0 3px 0;
    margin: 0;
  }
}
</style>
